/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { StarFilledIcon as icon } from '../../components/Icons';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Icon' ),
	description: __( 'Gutenify Icon' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'Icon' ),
	],
	example: {
		attributes: {
			image: {
				url: '',
				id: '',
			},
		},
	},
	attributes,
	edit,
	save,
	supports: {
		html: false,
		customClassName: true,
	},
	usesContext: [ 'my-plugin/recordId' ],
};

export { name, category, settings };
